import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nameValidator(control: AbstractControl): ValidationErrors | null {
  const { value } = control;

  if (!value) {
    return null;
  }

  // https://www.w3resource.com/javascript/form/email-validation.php
  // eslint-disable-next-line no-useless-escape
  if (/^[a-zA-Z0-9.'\-()\s]+$/.test(value)) {
    return null;
  }

  return { name: true };
}
